// Business hours for all Sıfır Bir Tuning branches (KKTC, UTC+3 / Europe/Istanbul).
export const OPEN_HOUR = 9;
export const CLOSE_HOUR = 18;
export const HOURS_LABEL = "09:00 – 18:00";
const TZ = "Europe/Istanbul";

export function isOpenNow() {
  let hour;
  try {
    const parts = new Intl.DateTimeFormat("en-GB", { timeZone: TZ, hour: "numeric", hour12: false }).formatToParts(new Date());
    const hp = parts.find((p) => p.type === "hour");
    hour = hp ? parseInt(hp.value, 10) : new Date().getHours();
  } catch {
    hour = new Date().getHours();
  }
  if (hour === 24) hour = 0;
  return hour >= OPEN_HOUR && hour < CLOSE_HOUR;
}
